import React from 'react';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedQueryParamUpdateProvider } from '../../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { ConnectedSharedWithMeSpace } from './ConnectedSharedWithMeSpace';
import { SharedWithMeSpaceOwnProps } from './SharedWithMeSpace';

export interface SharedWithMeSpaceProviderProps extends SharedWithMeSpaceOwnProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const SharedWithMeSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'sharedWithMe',
  subspaceName: undefined
};

export const SharedWithMeSpaceProvider: React.FunctionComponent<SharedWithMeSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={SharedWithMeSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={true}
        shouldUpdateFilters={false}
        shouldUpdateSort={false}
      ></ConnectedQueryParamUpdateProvider>
      <ConnectedSharedWithMeSpace {...{...props}}/>
    </ConnectedSpaceInfoProvider>
  );
};
